import * as query from "./query";
function foo() {
    console.log("!");
}
export { foo, query };
//# sourceMappingURL=index.js.map